export var TooltipOverflowMode;
(function (TooltipOverflowMode) {
  /** Only show tooltip if parent DOM element is overflowing */
  TooltipOverflowMode[TooltipOverflowMode["Parent"] = 0] = "Parent";
  /** Only show tooltip if tooltip host's content is overflowing */
  TooltipOverflowMode[TooltipOverflowMode["Self"] = 1] = "Self";
})(TooltipOverflowMode || (TooltipOverflowMode = {}));